import { useState } from "react";
import axiosInstance from "../../../api/axios";
import toast from "../../../shared/toast";
import { useNavigate } from "react-router-dom";

export default function NewNotificationType() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    type: "",
    image: null,
  });

  const [errors, setErrors] = useState({
    type: "",
    image: "",
  });

  const onChange = (e) => {
    if (e.target.name === "image") {
      setFormData((prevState) => ({
        ...prevState,
        image: e.target.files[0], // Kép fájl mentése
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const validateForm = () => {
    let formValid = true;
    let errors = {};

    if (!formData.type) {
      errors.type = "Az értesítés típusának megadása kötelező.";
      formValid = false;
    }

    if (!formData.image) {
      errors.image = "A kép feltöltése kötelező.";
      formValid = false;
    } else if (
      formData.image &&
      !["image/png", "image/jpeg", "image/jpg"].includes(formData.image.type)
    ) {
      errors.image = "Csak PNG, JPG vagy JPEG fájlokat tölthetsz fel.";
      formValid = false;
    }

    setErrors(errors);
    return formValid;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const userData = {
      type: formData.type,
      image: formData.image,
    };

    const formDataToSend = new FormData();
    formDataToSend.append("type", userData.type);
    formDataToSend.append("image", userData.image);

    axiosInstance
      .post("/api-admin/notifications/new-notification-type", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        toast("success", response.data.message);
        navigate("/notification-types");
        setFormData({
          type: "",
          image: null,
        });
      })
      .catch((error) => {
        console.error("Error posting data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast("error", error.response.data.message);
        } else {
          toast("error", "Szerver hiba");
        }
      });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header card-no-border pb-3">
              <h3>Új értesités típus létrehozása</h3>
            </div>
            <div className="card-body">
              <div className="horizontal-wizard-wrapper">
                <div className="row g-3">
                  <div className="col-12">
                    <div
                      className="tab-content dark-field"
                      id="horizontal-wizard-tabContent"
                    >
                      <div
                        className="tab-pane fade show active"
                        id="wizard-info"
                        role="tabpanel"
                        aria-labelledby="wizard-info-tab"
                      >
                        <form
                          className="row g-3 needs-validation basic-form"
                          onSubmit={onSubmit}
                        >
                          <div className="col-xl-4 col-sm-6">
                            <label
                              className="form-label"
                              htmlFor="notiTypeName"
                            >
                              Értesítés típusa
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              id="notiTypeName"
                              name="type"
                              type="text"
                              value={formData.type}
                              onChange={onChange}
                              placeholder="Értesítés típus megadása"
                            />
                            {errors.type && (
                              <p className="text-danger">{errors.type}</p>
                            )}
                          </div>

                          <div className="col-xl-4 col-sm-6">
                            <label className="form-label" htmlFor="image">
                              Kép feltöltése
                            </label>
                            <input
                              className="form-control"
                              type="file"
                              id="image"
                              name="image"
                              onChange={onChange}
                            />
                            {errors.image && (
                              <p className="text-danger">{errors.image}</p>
                            )}
                          </div>

                          <div className="col-12 text-end">
                            <button className="btn btn-primary">
                              Létrehozás
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
